var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      staticClass: "info-dialog",
      attrs: { "md-active": _vm.show },
      on: {
        "update:mdActive": function($event) {
          _vm.show = $event
        },
        "update:md-active": function($event) {
          _vm.show = $event
        },
        "md-closed": _vm.closeDialog
      }
    },
    [
      _c(
        "md-dialog-title",
        { staticClass: "text_large dialog-title" },
        [
          _c("span", [_vm._v(_vm._s(_vm.i18n.lbl_transaction_details()))]),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "md-icon-button md-raised md-dense close-btn",
              on: { click: _vm.closeDialog }
            },
            [_c("md-icon", [_vm._v("close")])],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "app__dialog-inner text_medium" },
        [
          _c("tx-details", {
            staticClass: "info-dialog__history",
            attrs: { tx: _vm.dialogValues }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35496950", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35496950","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/index/Dashboard.InfoDialog.vue
// module id = wgXs
// module chunks = 1